<template>
  <scout-form
    label="経験職種・希望職種"
    has-child
  >
    <div class="boss-table-2-layout">
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': desiredOccupations.length || experiencedOccupations.length }"
      >
        <div class="boss-separated-small">
          <div class="boss-layout boss-layout-start boss-layout-gap-large">
            <label
              v-for="(option, i) in options"
              :key="i"
              :data-test="`label-${i}`"
              class="pega-input"
            >
              <input
                :checked="selectedOption === option.key"
                :value="option.key"
                :data-test="`radio-${i}`"
                class="boss-input-checkbox"
                type="radio"
                @change="$emit('update:selectedOption', $event.target.value)"
              >{{ option.label }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      class="boss-table-2-layout"
      data-test="experienced-occupation"
    >
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        経験職種
      </div>
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': experiencedOccupations.length }"
        data-test="experienced-occupation-body"
      >
        <select-modal-button
          v-if="occupationsMaster.length > 0"
          :master-data="occupationsMaster"
          :selected-items="experiencedOccupations.map(o => { return { id: o, experience: '' } })"
          title="職種"
          suffix="experienced-occupations"
          data-test="experienced-occupation-modal"
          @update-modal-checked-ids="value => $emit('update:experiencedOccupations', value.map(o => o.id ))"
        />
      </div>
    </div>
    <div
      class="boss-table-2-layout"
      data-test="desired-occupation"
    >
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        希望職種
      </div>
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': desiredOccupations.length}"
        data-test="desired-occupation-body"
      >
        <label class="boss-checkbox">
          <input
            :checked="containOccupationsNonHopeUser"
            class="boss-input-checkbox"
            type="checkbox"
            data-test="check-box"
            @change="$emit('update:containOccupationsNonHopeUser', $event.target.checked)"
          >選択した希望職種を「どちらでもない・未入力」としている会員を含む
        </label>
        <select-modal-button
          v-if="occupationsMaster.length > 0"
          :master-data="occupationsMaster"
          :selected-items="desiredOccupations.map(o => { return { id: o, experience: '' } })"
          title="職種"
          suffix="desired-occupations"
          data-test="desired-occupation-modal"
          @update-modal-checked-ids="value => $emit('update:desiredOccupations', value.map(o => o.id))"
        />
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import * as definition from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    selectedOption: {
      default: '',
      type: String
    },
    experiencedOccupations: {
      required: true,
      type: Array
    },
    desiredOccupations: {
      required: true,
      type: Array
    },
    containOccupationsNonHopeUser: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      options: definition.occupationOperators
    }
  },
  computed: {
    ...mapGetters([
      'occupationsMaster'
    ])
  }
}
</script>
